// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const SPIN_LOADERS = "SPIN_LOADERS"
export const FIREBASE_STATE_CHANGED = 'FIREBASE_STATE_CHANGED';
